export * as seoSitemapEntries from '@wix/auto_sdk_seo_seo-sitemap-entries/schemas';
export * as seoTags from '@wix/auto_sdk_seo_seo-tags/schemas';
export * as robotsTxt from '@wix/auto_sdk_seo_robots-txt/schemas';
